﻿(function () {
    const CAUSE_OF_PAYMENT = {
        PURCHASE: 1,
        INVOICE: 2,
        PRE_PAYMENT: 3
    },

        app = {
            init: function () {
                app.initCampaignPage();
                const campaignPageContainerEl = document.querySelector('.campaign-sign-up');
                campaignPageContainerEl.classList.add('initialized');
            },
            state: {
                step: document.querySelector('#current-step').value
            },
            initCampaignPage: function () {
                const $gameProductSelectEl = $('#campaign-signup-select-product-dd'); // used to select game product in step 0. A change will set form campaign code
                const $campaignCodeInputEl = $('#CampaignSignUp_CampaignCode'); // the form campaign code input
                const campaignPage = {
                    signUp: {
                        show: function () {
                            const campaignSignUp = $('.campaign-sign-up');
                            const campaignHeroRightOverlay = $('#campaign-sign-up-overlay');
                            const isModalOpen = $("#is-modal-open");

                            campaignSignUp.removeClass('hide-step');
                            campaignHeroRightOverlay.css("visibility", "visible");
                            campaignHeroRightOverlay.css("opacity", "1");
                            $('body').addClass('no-scroll');
                            isModalOpen.val(true);
                            campaignPage.signUp.setTabIndex(campaignPage.signUp.elements.focusableElementsOnSite, false);
                            campaignPage.signUp.setTabIndex(campaignPage.signUp.elements.focusableElementsInSignUp, true);
                            campaignPage.signUp.setAriaHidden(true);
                            document.addEventListener('keydown', campaignPage.signUp.handleKeyDown);
                            window.LBSApp.FocusUtils.focusAndAdjust(document.querySelector('#steps-container h3') || document.querySelector(".campaign-sign-up-header h2"));
                            const termsModal = window.LBSApp.ModalUtils.create(document.querySelector('.js-Campaign-terms-container'));
                            document.querySelector('.js-Campaign-open-terms').addEventListener('click', termsModal.open);
                        },
                        hide: function () {
                            const campaignSignUpModal = $('.campaign-sign-up');
                            const campaignHeroRightOverlay = $('#campaign-sign-up-overlay');
                            const isModalOpen = $("#is-modal-open");

                            campaignSignUpModal.addClass('hide-step');
                            campaignHeroRightOverlay.css("visibility", "hidden");
                            campaignHeroRightOverlay.css("opacity", "0");
                            $('body').removeClass('no-scroll');
                            isModalOpen.val(false);
                            updatePaymentIdQueryString(null);
                            updateAgIdQueryString(null);
                            var shouldResetForm = document.querySelector('#current-step').value > '0'
                            if (shouldResetForm) {
                                // reset
                                let url = LBSApp.UrlHelpers.getUrlWithQueryStringParam(window.location.href, 'paymentId', null);
                                url = LBSApp.UrlHelpers.getUrlWithQueryStringParam(url, 'directDebitSessionId', null);
                                window.location.href = url;

                            }
                            campaignPage.signUp.restoreOriginalTabIndexes();
                            campaignPage.signUp.setTabIndex(campaignPage.signUp.elements.focusableElementsInSignUp, false);
                            campaignPage.signUp.setAriaHidden(false);
                            document.removeEventListener('keydown', campaignPage.signUp.handleKeyDown);
                        },
                        initializeElements: function () {
                            const campaignContainerEl = document.querySelector('.campaign-sign-up');
                            const focusableElementsSelector = 'button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"]), video, #campaign-container'; //campaign-container is scrollable

                            const campaignContainerFocusableElements = Array.from(campaignContainerEl.querySelectorAll(focusableElementsSelector));
                            const siteFocusableElements = Array.from(document.querySelectorAll(focusableElementsSelector))
                                .filter(element =>
                                    !campaignContainerFocusableElements.includes(element)
                                );

                            campaignPage.signUp.elements = {
                                closeButton: document.getElementById('campaign-sign-up-close-modal-button'),
                                backButton: document.getElementById('campaign-sign-up-step-back-button'),
                                campaignContainer: campaignContainerEl,
                                overlayContainer: document.getElementById('campaign-sign-up-overlay'),

                                focusableElementsInSignUp: campaignContainerFocusableElements,
                                focusableElementsOnSite: siteFocusableElements,
                                originalTabIndexes: campaignPage.signUp.getOriginalTabIndexes(siteFocusableElements),
                                form: document.getElementById('payment-form')
                            }
                        },
                        // get all original tab indexes and save them to be able to restore later
                        getOriginalTabIndexes: function (focusableElementsOnSite) {
                            const tabIndexes = new Map();
                            focusableElementsOnSite.forEach(item => {
                                tabIndexes.set(item, item.getAttribute('tabindex'));
                            });
                            return tabIndexes;
                        },
                        // restore all tabIndexes to their original state
                        restoreOriginalTabIndexes: function () {
                            campaignPage.signUp.elements.focusableElementsOnSite.forEach(item => {
                                const originalTabIndex = campaignPage.signUp.elements.originalTabIndexes.get(item);
                                if (originalTabIndex !== null) {
                                    item.setAttribute('tabindex', originalTabIndex);
                                } else {
                                    item.removeAttribute('tabindex');
                                }
                            });
                        },
                        setTabIndex: function (els, tabbable) {
                            els.forEach(el => {
                                if (tabbable) {
                                    el.removeAttribute('tabindex');
                                } else {
                                    el.setAttribute('tabindex', '-1');
                                }
                            });
                        },
                        setAriaHidden: function (shouldOpen) {
                            function setAriaHiddenToSiblings(element) {
                                var siblings = Array.prototype.filter.call(element.parentNode.children, function (child) {
                                    return child !== element;
                                });

                                siblings.forEach(function (sibling) {
                                    campaignPage.signUp.elements.originalAriaHiddenValues.set(sibling, sibling.getAttribute('aria-hidden'));
                                    sibling.setAttribute('aria-hidden', 'true');
                                });
                            }

                            function restoreAriaHiddenValues() {
                                campaignPage.signUp.elements.originalAriaHiddenValues.forEach(function (value, element) {
                                    if (value === null) {
                                        element.removeAttribute('aria-hidden');
                                    } else {
                                        element.setAttribute('aria-hidden', value);
                                    }
                                });
                            }

                            if (shouldOpen) {
                                campaignPage.signUp.elements.campaignContainer.removeAttribute('aria-hidden');

                                // set aria hidden on all siblings and all parent siblings
                                campaignPage.signUp.elements.originalAriaHiddenValues = new Map();
                                setAriaHiddenToSiblings(campaignPage.signUp.elements.campaignContainer, true);
                                var ancestor = campaignPage.signUp.elements.campaignContainer.parentNode;
                                while (ancestor !== document.body) {
                                    setAriaHiddenToSiblings(ancestor);
                                    ancestor = ancestor.parentNode;
                                }
                            }
                            else {
                                campaignPage.signUp.elements.campaignContainer.setAttribute('aria-hidden', 'true');
                                restoreAriaHiddenValues();
                            }
                        },
                        handleKeyDown: function (event) {
                            if (event.key === 'Escape') {
                                campaignPage.signUp.hide();
                            }
                        },
                    },
                    step1: {
                        init: function () {
                            LBSApp.Validations.addEmailValidation(campaignPage.step1.elements.email);
                            LBSApp.Validations.addCellphoneValidation(campaignPage.step1.elements.cellPhone);
                            LBSApp.Validations.personalNumberLiveFormatter(campaignPage.step1.elements.personalIdentityNumber);
                            LBSApp.Validations.addRequiredValidation(campaignPage.step1.elements.termsChecked);

                            campaignPage.signUp.elements.form.addEventListener('submit', function (evt) {
                                if (app.state.step == 0) {
                                    var isValid = campaignPage.step1.isValid();
                                    if (!isValid) {
                                        document.dispatchEvent(new Event('kombi.datumticketnumber.validate'));
                                        evt.stopPropagation();
                                        evt.preventDefault();
                                    }
                                    else {
                                        if (evt.submitter) {
                                            evt.submitter.classList.add('is-loading');
                                        }
                                    }
                                }
                            });
                        },
                        elements: {
                            email: document.getElementById('CampaignSignup_Step1_Email'),
                            cellPhone: document.getElementById('CampaignSignup_Step1_CellPhone'),
                            personalIdentityNumber: document.getElementById('CampaignSignup_Step1_PersonalIdentityNumber'),
                            termsChecked: document.getElementById('CampaignSignup_Step1_SignupChecked'),
                        },
                        hideErrorMessage: function () {
                            const step1ErrorContainer = $('#campaign-sign-up-step-1-error-container');
                            const step1ErrorMessage = $('#campaign-sign-up-step-1-error-message');

                            step1ErrorContainer.prop("hidden", true);
                            step1ErrorMessage.innerText = "";
                        },
                        displayErrorMessage: function (errorMessage) {
                            const step1ErrorContainer = $('#campaign-sign-up-step-1-error-container');
                            const step1ErrorMessage = $('#campaign-sign-up-step-1-error-message');

                            step1ErrorContainer.prop("hidden", false);
                            step1ErrorMessage.text(errorMessage);
                        },
                        enableEditing: function () {
                            const personalIdentityNumber = $('#CampaignSignup_Step1_PersonalIdentityNumber');
                            const submitButton = $('.Campaign-form-submit.js-campaign-new-step-1-button');
                            const updateButton = $('.Campaign-form-submit.js-campaign-new-step-1-edit-button');

                            personalIdentityNumber.prop("readOnly", true);
                            personalIdentityNumber.css("color", "#c0c0c0");

                            submitButton.prop("hidden", true);
                            updateButton.prop("hidden", false);
                        },
                        isValid: function () {
                            const userIsLoggedIn = $('.Campaign-form-submit.js-campaign-new-step-1-button.logged-in').length > 0;
                            const validCampaignSelected = $gameProductSelectEl.val() !== '';
                            const ticketNumberEl = document.querySelector('#ticketnumber');
                            const validTicketNumber = ticketNumberEl ? !!ticketNumberEl.value : true;

                            if (userIsLoggedIn) {
                                return validCampaignSelected && validTicketNumber;
                            } else {
                                const validEmail = document.getElementById('CampaignSignup_Step1_Email').lbsValidate(true);
                                const validCellPhoneNumber = document.getElementById('CampaignSignup_Step1_CellPhone').lbsValidate(true);
                                const signUpStep1TermsChecked = document.getElementById('CampaignSignup_Step1_SignupChecked').lbsValidate(true);
                                const validPersonalIdentityNumber = document.getElementById('CampaignSignup_Step1_PersonalIdentityNumber').lbsValidate(true);

                                const validCampaignSelected = $('#campaign-signup-select-product-dd').val() != '';

                                return validEmail &&
                                    validCellPhoneNumber &&
                                    signUpStep1TermsChecked &&
                                    validPersonalIdentityNumber &&
                                    validCampaignSelected &&
                                    validTicketNumber;
                            }

                        },
                        data: function () {
                            return {
                                campaignCode: $gameProductSelectEl.val(),
                                campaignName: $('#campaign-signup-select-product-dd :selected').text(),
                                email: $('#CampaignSignup_Step1_Email').val(),
                                cellPhone: $('#CampaignSignup_Step1_CellPhone').val(),
                                personalIdentityNumber: $('#CampaignSignup_Step1_PersonalIdentityNumber').val(),
                                signUpChecked: $('#CampaignSignup_Step1_SignupChecked').prop('checked')
                            }
                        }
                    },
                    step2: {
                        init: function () {
                            LBSApp.Validations.addRequiredValidation(campaignPage.step2.elements.terms);
                            campaignPage.signUp.elements.form.addEventListener('submit', function (evt) {
                                if (app.state.step == 1) {
                                    var isValid = campaignPage.step2.isValid();
                                    if (!isValid) {
                                        evt.stopPropagation();
                                        evt.preventDefault();
                                    }
                                    else {
                                        if (evt.submitter) {
                                            evt.submitter.classList.add('is-loading');
                                        }
                                    }
                                }
                            });
                        },
                        elements: {
                            terms: document.getElementById('CampaignSignup_Step2_SignUpPaymentChecked'),
                            paymentType: document.getElementById("CampaignSignup_Step2_PaymentType"),
                            directDebitSessionId: document.getElementById("DirectDebitSessionId")
                        },
                        stepBack: function () {
                            const stepBackButton = $('#campaign-sign-up-step-back-button');
                            const step2Container = $('#campaign-sign-up-step-2');
                            const step1Overlay = $('#campaign-sign-up-step-1-overlay');
                            const step1 = $('#campaign-sign-up-step-1');

                            campaignPage.step1.enableEditing();
                            stepBackButton.addClass("hide");
                            step2Container.css("box-shadow", "none");
                            step2Container.css("right", "-100%");
                            step2Container.addClass('hide-step');
                            step1Overlay.css("visibility", "hidden");
                            step1Overlay.css("opacity", "0");
                            step1.removeClass('hide-step');

                            $("#current-step").val(0);
                            updatePaymentIdQueryString(null);
                            updateAgIdQueryString(null);
                            app.state.step = 0;
                        },
                        show: function () {
                            const stepBackButton = $('#campaign-sign-up-step-back-button');
                            const step2Container = $('#campaign-sign-up-step-2');
                            const step1Overlay = $('#campaign-sign-up-step-1-overlay');

                            stepBackButton.removeClass("hide");
                            step2Container.css("right", "0");
                            step2Container.css("box-shadow", "0px 0px 30px rgb(0 0 0 / 25 %);");
                            step1Overlay.css("visibility", "visible");
                            step1Overlay.css("opacity", "1");
                        },
                        hide: function () {
                            const stepBackButton = $('#campaign-sign-up-step-back-button');
                            const step2Container = $('#campaign-sign-up-step-2');
                            const step1Overlay = $('#campaign-sign-up-step-1-overlay');

                            stepBackButton.addClass("hide");
                            step2Container.css("right", "-100%");
                            step2Container.css("box-shadow", "none");
                            step1Overlay.css("visibility", "hidden");
                            step1Overlay.css("opacity", "0");
                        },
                        reset: function () {
                            const paymentsListContainer = $("#payments-list-container");
                            paymentsListContainer.show();

                            $('#campaign-sign-up-step-back-button').prop('disabled', false);
                            $('#CampaignSignup_Step2_SignUpPaymentChecked').prop('disabled', false);
                            $('#payments-list-container').removeClass('disabled');

                            $('#payments-list-container ul li input').each(function () {
                                $(this).prop('disabled', false);
                            });
                        },
                        disableSubmit: function () {
                            const submitButton = $('.Campaign-form-submit.js-campaign-new-step-2-button');

                            submitButton.addClass("disabled");
                            submitButton.prop("disabled", true);
                        },
                        submit: function () {
                            campaignPage.step2.disableSubmit();
                            $('#payment-form').submit();
                        },
                        isValid: function () {
                            const termsChecked = campaignPage.step2.elements.terms.lbsValidate(true);
                            const hasPaymentType = !!campaignPage.step2.elements.paymentType.value && campaignPage.step2.elements.paymentType.value.toLowerCase() != "unknown";
                            return termsChecked && hasPaymentType;
                        }
                    },
                    step5: {
                        show: function () {
                            const step5Container = $('#campaign-information-missing');
                            const step1Overlay = $('#campaign-sign-up-step-1-overlay');

                            step5Container.removeClass("hide-step");
                            step5Container.css("right", "0");
                            step5Container.css("box-shadow", "0px 0px 30px rgb(0 0 0 / 25 %);");
                            step1Overlay.css("visibility", "visible");
                            step1Overlay.css("opacity", "1");

                        },
                        hide: function () {
                            const stepBackButton = $('#campaign-sign-up-step-back-button');
                            const step5Container = $('#campaign-sign-up-step-5');
                            const step1Overlay = $('#campaign-sign-up-step-1-overlay');

                            stepBackButton.addClass("hide");
                            step5Container.css("right", "-100%");
                            step5Container.css("box-shadow", "none");
                            step1Overlay.css("visibility", "hidden");
                            step1Overlay.css("opacity", "0");
                        },
                        submit: function () {
                            campaignPage.step5.hide();
                            campaignPage.step2.show();
                        },
                        isValid: function () {
                            const validEmail = LBSApp.Validations.validateEmail($('#CampaignSignup_Step5_Email').val());
                            const validCellPhoneNumber = LBSApp.Validations.validateCellPhoneNumber($('#CampaignSignup_Step5_CellPhone').val());

                            return validEmail && validCellPhoneNumber;
                        },
                    },
                    thankYou: function () {
                        const stepBackButton = $('#campaign-sign-up-step-back-button');
                        const container = $('#campaign-sign-up-thank-you');
                        const overlay = $('#campaign-sign-up-step-2-overlay');

                        stepBackButton.addClass("hide");
                        container.css("right", "0");
                        container.css("box-shadow", "0px 0px 30px rgb(0 0 0 / 25 %);");
                        overlay.css("visibility", "visible");
                        overlay.css("opacity", "1");
                    },
                    error: {
                        show: function () {
                            const stepBackButton = $('#campaign-sign-up-step-back-button');
                            const container = $('#campaign-sign-up-error');
                            const overlay = $('#campaign-sign-up-step-2-overlay');

                            stepBackButton.addClass("hide");
                            container.css("right", "0");
                            container.css("box-shadow", "0px 0px 30px rgb(0 0 0 / 25 %);");
                            overlay.css("visibility", "visible");
                            overlay.css("opacity", "1");
                        },
                        hide() {
                            const stepBackButton = $('#campaign-sign-up-step-back-button');
                            const container = $('#campaign-sign-up-error');
                            const overlay = $('#campaign-sign-up-step-2-overlay');

                            stepBackButton.removeClass("hide");
                            container.css("right", "-100%");
                            container.css("box-shadow", "none");
                            overlay.css("visibility", "hidden");
                            overlay.css("opacity", "0");
                            campaignPage.step2.reset();
                        }
                    }
                }

                function initCampaignPage() {
                    campaignPage.signUp.initializeElements();
                    campaignPage.signUp.setTabIndex(campaignPage.signUp.elements.focusableElementsInSignUp, false);
                    if (!campaignPage.signUp.elements.campaignContainer.classList.contains('hide-step')) {
                        campaignPage.signUp.show();
                    }
                    campaignPage.step1.init();
                    campaignPage.step2.init();
                    const campaignCode = $campaignCodeInputEl.val();
                    if (!!campaignCode) {
                        setCampaignCode(campaignCode, true);
                    }
                    initDirectDebit();
                }

                function initDirectDebit() {
                    function getDirectDebitFormData() {
                        const formData = getFormData();
                        return {
                            type: 'purchase',
                            campaignCode: formData.campaignCode,
                            Phone: formData.mobile,
                            Email: formData.email,
                            PersonalIdentityNumber: formData.ssn,
                            PaymentMethod: 'DirectDebit',
                            CustomerId: formData.customerId,
                            RequestedTicketNumber: formData.requestedTicketNumber
                        };
                    }

                    campaignPage.directDebit = {
                        getFormData: getDirectDebitFormData
                    };

                    LBSApp.EventBus.subscribe(LBSApp.EventBus.events.DIRECT_DEBIT_REGISTRATION_SIGNED, (evt) => {
                        campaignPage.step2.elements.directDebitSessionId.value = evt.detail.sessionId;
                        submitPayment();
                    });

                    LBSApp.EventBus.subscribe(LBSApp.EventBus.events.DIRECT_DEBIT_REGISTRATION_INITIATED, (evt) => {
                        state['directDebitHasLoaded'] = evt.detail.sessionId;
                        campaignPage.step2.elements.directDebitSessionId.value = evt.detail.sessionId;
                    });

                    LBSApp.EventBus.subscribe(LBSApp.EventBus.events.DIRECT_DEBIT_REGISTRATION_CANCELED, (evt) => {
                        state['directDebitHasLoaded'] = null;
                        updateAgIdQueryString(null);
                        campaignPage.step2.elements.directDebitSessionId.value = null;
                    });

                    const directDebitFormData = campaignPage.directDebit.getFormData();
                    LBSApp.EventBus.publish(
                        LBSApp.EventBus.events.DIRECT_DEBIT_REGISTRATION_SYNC_ADDITIONAL_DATA,
                        {
                            personalIdentityNumber: directDebitFormData ? directDebitFormData.PersonalIdentityNumber : null,
                            formData: directDebitFormData ? [directDebitFormData] : null
                        }
                    );
                }

                function validateAssociationSale() {
                    const isValid = !!$campaignCodeInputEl.val();
                    document.dispatchEvent(new Event('kombi.assoicationsale.validate'));
                    if (!isValid) {
                        $('html, body').animate({
                            scrollTop: 0
                        }, 500);
                    }
                    return isValid;
                }

                $('.js-Campaign-personal-identity-number').on('keyup',
                    function (e) {
                        if ((e.which >= 46 && e.which <= 57) || ((e.which >= 96 && e.which <= 105))) {
                            var birthYear = parseInt($(this).val());
                            if ($(this).val().length === 2 &&
                                birthYear !== NaN &&
                                birthYear !== 19 &&
                                birthYear !== 20) {
                                if (birthYear > 9) {
                                    $(this).val('19' + birthYear);
                                } else {
                                    $(this).val('200' + birthYear);
                                }
                            }
                        }
                    }
                );

                //on page reload due to validation errors.

                if ($('#CampaignSignup_Step2_SignUpPaymentChecked').is(':checked')) {
                    $('#payments-container').show();
                }

                $('#CampaignSignup_Step2_SignUpPaymentChecked').on('click',
                    function () {
                        var formEnabled = $(this).is(':checked');

                        formEnabled ? $('#payments-container').show() : $('#payments-container').hide();

                        if (formEnabled) {
                            $('#campaign-container').animate({
                                scrollTop: $('#payments-container').offset().top - 400
                            },
                                1000);

                            if ($("#exisiting-payment-type").length > 0) {
                                const selectedItem = app.getSelectedProductGtmItem();
                                window.LBSApp.GTM.Ecommerce.beginCheckout(window.LBSApp.GTM.GtmPageData, selectedItem);
                                $("#submit-payment").show();
                            }
                        } else {

                            if ($("#exisiting-payment-type").length > 0) {
                                $("#submit-payment").hide();
                            }
                        }
                    });

                function enableCampaignStep1Button() {
                    if ($('.Campaign-form-submit.js-campaign-new-step-1-button.logged-in').length > 0) {
                        const validCampaignSelected = $gameProductSelectEl.val() !== '';
                    } else {
                        const validEmail = LBSApp.Validations.validateEmail($('#CampaignSignup_Step1_Email').val());
                        const validCellPhoneNumber = LBSApp.Validations.validateCellPhoneNumber($('#CampaignSignup_Step1_CellPhone').val());
                        const signUpStep1TermsChecked = $('#CampaignSignup_Step1_SignupChecked').is(':checked');
                        const validPersonalIdentityNumber =
                            LBSApp.Validations.validatePersonalIdentityNumber($('#CampaignSignup_Step1_PersonalIdentityNumber').val(),
                                'LONG');
                        const validCampaignSelected = $gameProductSelectEl.val() !== '';
                    }
                }


                $('#CampaignSignup_Step1_Email').on('focusout',
                    function (e) {
                        enableCampaignStep1Button();
                    }
                );

                $('#CampaignSignup_Step1_CellPhone').on('focusout',
                    function (e) {
                        enableCampaignStep1Button();
                    }
                );

                $('#CampaignSignup_Step1_PersonalIdentityNumber').on('change focusout',
                    function (e) {
                        enableCampaignStep1Button();
                    }
                );

                $gameProductSelectEl.on('change', function (e) {
                    var campaignCode = $gameProductSelectEl.val();
                    $campaignCodeInputEl.val(campaignCode);
                    enableCampaignStep1Button();
                });

                function setCampaignCode(campaignCode, isInit = false) {
                    const dropdownOptions = Array.from($gameProductSelectEl[0].querySelectorAll("option"));
                    const dropdownOptionIndex = dropdownOptions.findIndex(x => x.value === campaignCode);
                    const newSelectedItem = $gameProductSelectEl[0].selectedIndex != dropdownOptionIndex;

                    if (newSelectedItem) {
                        $gameProductSelectEl[0].selectedIndex = dropdownOptionIndex;
                        $gameProductSelectEl.trigger("change");
                        $campaignCodeInputEl.val(campaignCode);


                        if (!isInit) {
                            const gtmItem = window.LBSApp.GTM.GtmPageData.items.find(x => x.item_id === campaignCode);
                            window.LBSApp.GTM.Ecommerce.selectItem(window.LBSApp.GTM.GtmPageData, gtmItem);
                        }
                    }

                }

                $('.campaign-choose-product-button').each(function (index, button) {
                    $(button).click(function (evt) {
                        const isUserLoggedIn = $("#is-user-logged-in").val() === "True";

                        const type = button.getAttribute('data-game-product-type');
                        if (type === 'gameProductAssociation') {
                            if (!validateAssociationSale()) {
                                return;
                            }
                        }
                        else {
                            setCampaignCode(button.value)
                        }

                        const currentStep = $("#current-step").val();
                        // if user is signed in there is no need to show step 1 where you enter contact info
                        // Exception to this is if the user must select a ticket number, this is done in step 1
                        if (isUserLoggedIn === "True" && !document.querySelector('#ticketnumber')) {
                            $("#payment-form").submit();
                        } else {
                            campaignPage.signUp.show();
                        }
                    });
                });

                $('.campaign-detailed-info-button').each(function (index, button) {
                    $(button).click(function () {
                        setCampaignCode($(button).val());
                        const isUserLoggedIn = $("#is-user-logged-in").val() === "True";
                        // if user is signed in there is no need to show step 1 where you enter contact info
                        // Exception to this is if the user must select a ticket number, this is done in step 1
                        if (isUserLoggedIn === "True" && !document.querySelector('#ticketnumber')) {
                            if ($("#current-step").val() === "1") {
                                $("#current-step").val(0);
                                $("#payment-form").submit();
                            }
                        } else {
                            campaignPage.signUp.show();
                        }
                    });
                });

                $('#campaign-sign-up-thank-you-button').click(function () {
                    campaignPage.signUp.hide();
                });

                $('#campaign-sign-up-close-modal-button').click(function () {
                    campaignPage.signUp.hide();
                });

                $('#campaign-sign-up-overlay').click(function () {
                    campaignPage.signUp.hide();
                });

                $('#campaign-sign-up-step-back-button').click(function () {
                    campaignPage.step2.stepBack();
                });

                // payments - can this be extracted to a shared component used in my payments aswell?
                // swedbank.js is used in payments today but lots of logic is shared between these.

                function initSelectPaymentTypeSelector() {
                    $('.payments-list li').on('click', function (e) {
                        var input = $(this).find('input');

                        if (!$(e.target).is('input')) {
                            input.prop("checked", true);
                        }
                        var paymentType = input.val();

                        showPaymentType(paymentType);
                    });
                }

                initSelectPaymentTypeSelector();

                function showPaymentType(paymentType, publishEvent = true, speed = 1000) {
                    $('.payment-info').hide();

                    $('#payment-' + paymentType).show();
                    $('#campaign-container').animate({
                        scrollTop: $('#payment-' + paymentType).offset().top
                    }, speed);
                    $('#submit-payment').hide();
                    if (publishEvent) {
                        pubsub(paymentType).publish(paymentType);
                    }
                }

                var topics = {};

                var pubsub = function (id) {
                    var callbacks,
                        topic = id && topics[id];
                    if (!topic) {
                        callbacks = jQuery.Callbacks();
                        topic = {
                            publish: callbacks.fire,
                            subscribe: callbacks.add,
                            unsubscribe: callbacks.remove
                        };
                        if (id) {
                            topics[id] = topic;
                        }
                    }
                    return topic;
                };

                var state = {
                    cardHasLoaded: false,
                    swishHasLoaded: false,
                    directDebitHasLoaded: false
                };

                pubsub('card').subscribe(function (paymentType) {
                    setPaymentType(paymentType);
                    handleSwedbankPayment(paymentType);
                    updateAgIdQueryString(null);
                });
                pubsub('swish').subscribe(function (paymentType) {
                    setPaymentType(paymentType);
                    handleSwedbankPayment(paymentType);
                    updateAgIdQueryString(null);
                });
                pubsub('direct-debit').subscribe(function (paymentType) {
                    setPaymentType(paymentType);
                    handleDirectDebitPayment();
                    updatePaymentIdQueryString(null);
                });
                pubsub('invoice').subscribe(function (paymentType) {
                    setPaymentType(paymentType);
                    $('#submit-payment').show();
                    updatePaymentIdQueryString(null);
                });

                function setPaymentType(type) {
                    const currentValue = document.getElementById("CampaignSignup_Step2_PaymentType").value;
                    if (type === 'direct-debit') {
                        type = 'DirectDebit';
                    }

                    if (currentValue && type && (currentValue.toLowerCase() != type.toLowerCase())) {
                        document.getElementById("CampaignSignup_Step2_PaymentType").value = type;
                        window.LBSApp.GTM.Ecommerce.addPaymentInfo(window.LBSApp.GTM.GtmPageData, app.getSelectedProductGtmItem(), type);
                    }

                }

                function getFormData() {
                    return {
                        campaignCode: $campaignCodeInputEl.val(),
                        mobile: $("#CampaignSignup_Step1_CellPhone").val() || $("#CampaignSignup_Step5_CellPhone").val(),
                        email: $("#CampaignSignup_Step1_Email").val() || $("#CampaignSignup_Step5_Email").val(),
                        ssn: $("#CampaignSignup_Step1_PersonalIdentityNumber").val(),
                        customerId: $("#CampaignSignUp_Step2_CustomerId").val(),
                        causeOfPayment: CAUSE_OF_PAYMENT.PURCHASE,
                        requestedTicketNumber: $('#ticketnumber').val()
                    };
                }

                function handleDirectDebitPayment() {
                    var recurringPaymentSegment = document.getElementById("payment-direct-debit");
                    recurringPaymentSegment.hidden = false;
                    if (!state['directDebitHasLoaded']) {
                        const directDebitFormData = campaignPage.directDebit.getFormData();
                        LBSApp.EventBus.publish(
                            window.LBSApp.EventBus.events.DIRECT_DEBIT_REGISTRATION_SYNC_ADDITIONAL_DATA,
                            {
                                personalIdentityNumber: directDebitFormData ? directDebitFormData.PersonalIdentityNumber : null,
                                formData: directDebitFormData ? [directDebitFormData] : null
                            }
                        );
                    }
                    else {
                        updateAgIdQueryString(state['directDebitHasLoaded']);
                    }
                    
                }

                function handleSwedbankPayment(paymentType, paymentUrl, paymentId) {
                    if (!state[paymentType + 'HasLoaded']) {
                        state[paymentType + 'HasLoaded'] = true;
                        if (!paymentUrl) {
                            const signUpData = getFormData();

                            var purchase = {
                                campaignCode: signUpData.campaignCode,
                                mobile: signUpData.mobile,
                                email: signUpData.email,
                                ssn: signUpData.ssn,
                                paymentType: paymentType,
                                paymentUrl: LBSApp.UrlHelpers.getUrlWithQueryStringParam(window.location.href, 'paymentId', ''),
                                causeOfPayment: signUpData.causeOfPayment,
                                customerId: signUpData.customerId,
                                requestedTicketNumber: signUpData.requestedTicketNumber
                            };

                            fetch('/umbraco/api/payment/InitializePayment', {
                                method: 'POST',
                                body: JSON.stringify(purchase),
                                headers: {
                                    'Content-Type': 'application/json'
                                }
                            })
                                .then(res => res.json())
                                .then(res => {
                                    $('#payment-' + paymentType).find('.loading-spinner-wrapper').hide();

                                    if (res.errorType !== 0) {
                                        handleError(false, res.errorMessage, res.errorType, paymentId);
                                        return;
                                    }
                                    state[paymentType + 'HasLoaded'] = res.paymentId;
                                    initSwedbank(paymentType, res.paymentId, res.redirectUri, res.externalPaymentId);
                                })
                                .catch(err => handleError(false, undefined, undefined, paymentId))
                        } else {
                            state[paymentType + 'HasLoaded'] = paymentId;
                            $('#payment-' + paymentType).find('.loading-spinner-wrapper').hide();
                            initSwedbank(paymentType, paymentId, paymentUrl);
                        }
                    } else if (typeof (state[paymentType + 'HasLoaded']) === 'string') {
                        paymentId = state[paymentType + 'HasLoaded'];
                        updatePaymentIdQueryString(paymentId);
                    }
                }

                let disableInputs = function () {
                    $('#campaign-sign-up-step-back-button').prop('disabled', true);
                    $('#CampaignSignup_Step2_SignUpPaymentChecked').prop('disabled', true);
                    $('#payments-list-container').addClass('disabled');

                    $('#payments-list-container ul li input').each(function () {
                        $(this).prop('disabled', true);
                    });
                }

                let enableInputs = function () {
                    $('#campaign-sign-up-step-back-button').prop('disabled', false);
                    $('#CampaignSignup_Step2_SignUpPaymentChecked').prop('disabled', false);
                    $('#payments-list-container').removeClass('disabled');

                    $('#payments-list-container ul li input').each(function () {
                        $(this).prop('disabled', false);
                    });
                }

                const PAYMENT_EVENT_TYPE = {
                    PENDING: 1,
                    COMPLETED: 2,
                    ERROR: 3
                }
                var pendingState = PAYMENT_EVENT_TYPE.PENDING;

                function initSwedbank(paymentType, paymentId, paymentUrl, externalPaymentId) {
                    // in case the user swich payment types quickly and the api response come out of sync
                    let currentPaymentType = document.getElementById('CampaignSignup_Step2_PaymentType').value;
                    if (paymentType == currentPaymentType) {
                        updatePaymentIdQueryString(paymentId);
                    }

                    var script = document.createElement('script');
                    script.id = paymentType + "_script"
                    script.setAttribute('src', paymentUrl);
                    script.onerror = function () {
                        handleError(false, undefined, undefined, paymentId);
                    };
                    script.onload = function () {
                        var hostedViewFunc = getPaymentPageFunction(paymentType);
                        if (!hostedViewFunc) {
                            handleError(false, undefined, undefined, paymentId);
                            return;
                        }
                        hostedViewFunc({
                            container: "swedbank-pay-seamless-view-page-payment-" + paymentType,
                            culture: 'sv-SE',
                            onPaymentPending: function () {
                                disableInputs();
                                updatePaymentStatus(paymentId, externalPaymentId, PAYMENT_EVENT_TYPE.PENDING);
                            },
                            onPaymentCompleted: function () {
                                updatePaymentStatus(paymentId, externalPaymentId, PAYMENT_EVENT_TYPE.COMPLETED);
                            },
                            onPaymentCanceled: function () {
                                enableInputs();
                                updatePaymentStatus(paymentId, externalPaymentId, PAYMENT_EVENT_TYPE.ERROR);
                            },
                            onPaymentFailed: function () {
                                enableInputs();
                                updatePaymentStatus(paymentId, externalPaymentId, PAYMENT_EVENT_TYPE.ERROR);
                            },
                            onError: function () {
                                enableInputs();
                                updatePaymentStatus(paymentId, externalPaymentId, PAYMENT_EVENT_TYPE.ERROR);
                            },
                            onPaymentTransactionFailed: function (e, o) {
                                enableInputs();
                                updatePaymentStatus(paymentId, externalPaymentId, PAYMENT_EVENT_TYPE.ERROR);
                            },
                            onApplicationConfigured: function () {
                                if (pendingState != PAYMENT_EVENT_TYPE.COMPLETED) {
                                    setPaymentListVisibility(true);
                                }
                            }
                        }).open();
                    };
                    var head = document.getElementsByTagName('head')[0];
                    head.appendChild(script);
                }

                function setPaymentListVisibility(show) {
                    const paymentMethodListEl = document.getElementById('payments-list-container');
                    if (paymentMethodListEl) {
                        if (show) {
                            paymentMethodListEl.classList.remove('hide-step');
                        }
                        else {
                            paymentMethodListEl.classList.add('hide-step');
                        }
                    }
                }

                function updatePaymentIdQueryString(paymentId) {
                    LBSApp.UrlHelpers.updateQueryStringParam('paymentId', paymentId);
                }

                function updateAgIdQueryString(agId) {
                    LBSApp.UrlHelpers.updateQueryStringParam('directDebitSessionId', agId);
                }

                // update the paymentstatus in LBS. This will regsiter the payment directly. If this for some reason is not called, LBS will poll swedbank for the paymentstatus.
                // So if the payment succeded in swedbank it will be registered in LBS after a while.
                function updatePaymentStatus(paymentId, externalPaymentId, eventType) {
                    pendingState = eventType;
                    const data = {
                        paymentId: paymentId,
                        event: eventType
                    };

                    if (pendingState === PAYMENT_EVENT_TYPE.COMPLETED) {
                        setPaymentListVisibility(false);
                    }
                    fetch('/umbraco/api/payment/UpdatePaymentState', {
                        method: 'POST',
                        body: JSON.stringify(data),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                        .then(res => {
                            if (res.status !== 200) {
                                handleError(true, undefined, undefined, paymentId);
                            }
                            else {
                                res.json().then(success => {
                                    if (success === false) {
                                        handleError(true, undefined, undefined, paymentId);
                                    }
                                    else if (eventType === PAYMENT_EVENT_TYPE.COMPLETED) {
                                        $('#PaymentId').val(paymentId);
                                        submitPayment();
                                    }
                                });
                            }
                        })
                        .catch(error => handleError(true, undefined, undefined, paymentId))
                }

                function submitPayment() {
                    //HTML standard says that disabled inputs wont be sent with the form, so we enabled it before submiting
                    $('#CampaignSignup_Step2_SignUpPaymentChecked').prop('disabled', false);
                    campaignPage.step2.submit();
                }

                function handleError(paymentMightHaveSucceeded, msg, type, paymentId) {
                    $('#campaign-container').hide();
                    $('.custom-error-message').empty();
                    $('.error-message').empty();

                    var enableRetry = !paymentMightHaveSucceeded;

                    if (!paymentMightHaveSucceeded) {
                        //these are the errortypes they want to enable retry on.
                        if ([1, 6, 50, 51, 52, 53, 54, 70, 72, 92].indexOf(type) !== -1)
                            enableRetry = true;
                    }

                    if (enableRetry) {
                        $('#try-again').show();
                    } else {
                        $('#try-again').hide();
                    }

                    if (!msg) {
                        msg = "Någonting gick fel med din betalning. Vänligen kontakta kundservice 08-453 54 00.";
                    }

                    $('.error-message').text(msg);

                    var errorText = '';
                    if (paymentId) {
                        errorText += 'Betalningsreferens: ' + paymentId.replaceAll('-', '') + '<br/>';
                    }
                    if (type) {
                        errorText += 'Felkod: ' + type;
                    }

                    $('.custom-error-message').html(errorText);

                    $('#error-container').show();

                    $('#campaign-container').animate({
                        scrollTop: $('#error-container').offset().top - 400
                    }, 1000);
                }

                function getPaymentPageFunction(paymentType) {
                    if (window.payex === undefined) {
                        return null;
                    }
                    switch (paymentType) {
                        case "card":
                            return window.payex.hostedView.creditCard;
                        case "invoice":
                            return window.payex.hostedView.invoice;
                        case "swish":
                            return window.payex.hostedView.swish;
                        default:
                            return null;
                    }
                }

                if (document.getElementById('current-step').value == 1) {
                    let paymentType = document.getElementById('CampaignSignup_Step2_PaymentType').value;
                    const useExistingMethod = document.getElementById('CampaignSignup_Step2_UseExistingPaymentMethod').value;
                    if (paymentType && useExistingMethod.toLowerCase() == 'false') {
                        paymentType = paymentType.toString().toLowerCase();
                        if (paymentType == "swish" || paymentType == "card") {
                            const e_paymentIdEl = document.getElementById('ExternalPaymentId');
                            const e_paymentMethodEl = document.getElementById('ExternalPaymentMethod');
                            const e_paymentRedirectUriEl = document.getElementById('ExternalPaymentRedirectUri');

                            if (!!e_paymentRedirectUriEl.value) {
                                document.querySelector('.payments-list > #' + paymentType + ' input').checked = true
                                showPaymentType(paymentType, false, 0);
                                handleSwedbankPayment(e_paymentMethodEl.value, e_paymentRedirectUriEl.value, e_paymentIdEl.value);
                                e_paymentIdEl.value = '';
                                e_paymentMethodEl.value = '';
                                e_paymentRedirectUriEl.value = '';
                            }
                        }
                        else if (paymentType === 'directdebit') {
                            const directDebitTypeId = 'direct-debit'
                            const directDebitOptionEl = document.querySelector('.payments-list > #' + directDebitTypeId + ' input');
                            if (directDebitOptionEl) {
                                directDebitOptionEl.checked = true;
                            }
                            showPaymentType(directDebitTypeId, false, 0);
                        }
                    }
                }

                if ($("#campaign-sign-up-retry-button").length > 0) {
                    const button = $("#campaign-sign-up-retry-button");
                    button.on("click", function () {
                        window.location.replace(window.location.href);
                    });
                }

                initCampaignPage();
            },
            getSelectedProductGtmItem: function () {
                const dropdown = document.querySelector('#campaign-signup-select-product-dd');
                const selectedCampaignCode = dropdown.value || document.querySelector('#CampaignSignUp_CampaignCode').value;
                const gtmItem = window.LBSApp.GTM.GtmPageData.items.find(x => x.item_id === selectedCampaignCode);
                return gtmItem;
            },




        };

    //$(document).ready(app.init);
    document.addEventListener("DOMContentLoaded", app.init);
    
})();
